import formularioMutattion from './mutations/formulario.mutations'
import pessoaMutation from './mutations/pessoa.mutation'
import {USER_CONFIG} from '../config/UserConfig'
import storageService from '../services/storageService'

function obterPerguntasValidas(sessoesFormulario){
  let perguntasValidas = []
  if(sessoesFormulario && sessoesFormulario.length){

    sessoesFormulario.forEach(sessao=> {
      const {perguntas} = sessao;
      const perguntasObrigatoriasVisiveis = perguntas.filter(p=>p.visivel && p.obrigatoria);
      if(perguntasObrigatoriasVisiveis && perguntasObrigatoriasVisiveis.length){
        perguntasValidas = perguntasValidas.concat(perguntasObrigatoriasVisiveis)
      }
    })
  }

  return perguntasValidas
}

function perguntasValidarRespostaPorValor(state){

  const {formulario} = state;
  const {preValidacoesRespostas} = formulario; //preValidacoesRespostas é um array
  const perguntas = []

  preValidacoesRespostas && preValidacoesRespostas.map(preValidacao=> {

    const {preValidacoesRespostaPergunta, codigo} = preValidacao;
      const result = preValidacoesRespostaPergunta.map(validacaoRespotaPergunta=> {
        const {perguntaId,gatilhoValidacao, chavePergunta, textoExibicao} = validacaoRespotaPergunta;
        perguntas.push( {codigo,perguntaId, gatilhoValidacao, chavePergunta,textoExibicao});
      })

      return result;
  })
  //preValidacoesRespostaPergunta:Array

  //retorno {codigo:1,id:1,perguntas:[]}
  //somete perguntas com gatilho
  return perguntas || [];
}


const getters = {
  totalPerguntasVisiveis: state => {
    const {formulario} = state;
    const {sessoesFormulario} = formulario

    let totalPerguntas = 0;

    if(sessoesFormulario) {
      sessoesFormulario.forEach(sessao=> {
        totalPerguntas+= sessao.perguntas.filter(p=>p.visivel).length
      });
    }


    return totalPerguntas;



  },
  configuracaoFormulario: state => {
    // schema
    let config = {
      msgRespostaObrigatoriaResponderFormulario:"",
      labelBotaoVerificarResposta:"",
      msgRespostaEnviadaComSucesso:""
    };

    const {formulario} = state;
    const {configuracoesFormulario} = formulario;



    if(configuracoesFormulario && Array.isArray(configuracoesFormulario)){

      configuracoesFormulario.forEach(configuracao=> {
        config[configuracao.chave] = configuracao.valor;
      });
    }

    return config;
  },
  obterTemplateHTMLPerguntasRespondidas:state => {

      const {perguntasRespondidas} = state;

      //extrair estrutura de perguntas e respsotas
      const perguntasRespondidasMock = perguntasRespondidas
                                        .map(perguntaRespondida=> ({...perguntaRespondida.pergunta, respostas:[...perguntaRespondida.respostas]  }))
                                        .sort((pa,pb)=> pa.ordemExibicao - pb.ordemExibicao);

      function montarRespostas(respostas){

        if(!(respostas && respostas.length)) return;

        let templaterespostas = '';

        if(respostas.length > 1) {
          templaterespostas +=`<small><span>Respostas: </span></small><br>
          ${respostas.map(resposta=> `- <small><b>${resposta.valor}</b></small><br />`).join("")}
          `;
        }else{
            templaterespostas +=`<small><span>Resposta:</span> <b>${respostas[0].valor}</b></small><br>`
        }


        return templaterespostas;

      }

      let template = `
        <div style='text-align:left !important'>
          ${
            perguntasRespondidasMock.map(pergunta=> {
              return `<p style='margin-top:5px'>
                <small>${pergunta.ordemExibicao}) ${pergunta.titulo}</small> <br />
                ${montarRespostas(pergunta.respostas)}
              </p>`
            }).join("")
          }
        </div>
      `;


      if(perguntasRespondidasMock.length > 1) {
         template += `<p style='margin-top:5px;'><strong>Você confirma suas respostas?</strong></p>`;
      }else{
        template += `<p style='margin-top:5px;'><strong>Você confirma sua resposta?</strong></p>`;
      }

      return template;

  },
  syncParticipante:state => {
    let {participante} = state;
    if(participante && !participante.pessoaId){
      participante = storageService.getJsonItem(USER_CONFIG.loggedUser);
      if(participante && participante.pessoaId){
        pessoaMutation.ADD_PESSOA_PARTICIPANTE(state,participante);
      }
    }
    return participante;
  },
  versao: state => state.versao,
  formularioCarregado: state => (state.formulario && state.formulario.formularioId > 0),
  clienteValido:state => {
    const valid = state.clienteFormulario
                  && state.clienteFormulario
                  && state.clienteFormulario.apelidoUnico
                  && state.clienteFormulario.apelidoUnico.length > 0
                  && state.clienteFormulario.codigoCliente
                  && state.clienteFormulario.codigoCliente !=''
    return valid;
  },
  sessoesFormulario: state => state.formulario.sessoesFormulario,
  totalSessoesFormulario: state => state.formulario.sessoesFormulario ? state.formulario.sessoesFormulario.length : 0,
  totalPerguntasFormulario: state => state.totalPerguntas,
  totalPerguntasRespondidas: state => state.perguntasRespondidas.length,
  podeEnviarFormulario: (state)=> {

    const {formulario} = state;
    const {sessoesFormulario=[]} = formulario;

    let perguntasValidas = obterPerguntasValidas(sessoesFormulario);

    const totalPerguntasObrigatoriasVisiveis = perguntasValidas.length;
    const totalPerguntasRespondidas = state.perguntasRespondidas.length;
    const totalPerguntasRespondidasObrigatorias =  state.perguntasRespondidas.filter(pr=>pr.pergunta.obrigatoria ==true).length ||0

    const podeEnviar =  (totalPerguntasRespondidas> 0 && totalPerguntasRespondidasObrigatorias >= totalPerguntasObrigatoriasVisiveis)
    const semRestricaoPreValidacao = state.restricoesPreValidacao.length <=0

    const podeEnviarFormulario = podeEnviar && semRestricaoPreValidacao;

    if(podeEnviarFormulario){
      //alterar o state para desabilitar a verificação de resposta
      formularioMutattion.HABILITAR_VERIFICACAO_RESPOSTA(state,false);
    }

    return podeEnviarFormulario
  },
  perguntasNaoRespondidasParaSumario : state => {
    const {verificacaoRespostaHabilitado} = state;

    if (!verificacaoRespostaHabilitado) return [];

    const {formulario} = state;
    const {sessoesFormulario=[]} = formulario;

    let perguntasValidas = obterPerguntasValidas(sessoesFormulario);
    const idsPerguntasNaoRespondidas = getters.perguntasNaoRespondidas(state);
    const arrPerguntasSumarioErro = [];

    sessoesFormulario
      .map(sessao=> {
        sessao.perguntas
        .filter(perguntaOrdenada=>idsPerguntasNaoRespondidas.includes(perguntaOrdenada.sessaoFormularioPerguntaId))
        .map(perguntaOrdenada => {
          const {ordemExibicao,perguntaId,sessaoFormularioPerguntaId} = perguntaOrdenada;
          const pergunta = perguntasValidas.find(p=>p.sessaoFormularioPerguntaId == sessaoFormularioPerguntaId);

          if(pergunta && pergunta.sessaoFormularioPerguntaId){
            const {titulo,subtitulo} = pergunta;
            arrPerguntasSumarioErro.push({
              perguntaId,
              sessaoFormularioPerguntaId,
              titulo,
              subtitulo,
              ordemExibicao
            })
          }
        });
      })



    return arrPerguntasSumarioErro;
  },
  perguntasNaoRespondidas: state => {
    //pegar todas as perguntas respondidas
    const {perguntasRespondidas, formulario} = state;
    let arrFinalPerguntaSemResposta = []

    //pegar todas as perguntas
    const {sessoesFormulario=[]} = formulario;
    let perguntasValidas = obterPerguntasValidas(sessoesFormulario);

    //pegar so o ID das perguntas validas
    const perguntasValidasIds = perguntasValidas.map(p=>p.sessaoFormularioPerguntaId);

    const perguntasRespondidasIds = perguntasRespondidas.map(p=>p.sessaoFormularioPerguntaId);



    if(perguntasRespondidasIds && !perguntasRespondidasIds.length){
      //nenhuma pergunta respondida
      arrFinalPerguntaSemResposta = [...perguntasValidasIds]
    }else{
      const perguntasFaltamResponder = [];
        perguntasValidasIds.forEach(sessaoFormularioPerguntaId=> {
          const foiRespondida = perguntasRespondidasIds.includes(sessaoFormularioPerguntaId);
          if(!foiRespondida){
            perguntasFaltamResponder.push(sessaoFormularioPerguntaId)
          }
        })


      arrFinalPerguntaSemResposta =[...perguntasFaltamResponder]
    }

    return arrFinalPerguntaSemResposta;

  },

  respostaFormulario:(state)=>{

    let {formulario, perguntasRespondidas, participante} = state;
    const {formularioId,termoId} = formulario;
    if(participante && !participante.pessoaId){
      participante = getters.syncParticipante(state);
    }
    let {pessoaId, responsavelInteracao, responsavelInteracaoNome} = participante;

    //teste
    // pessoaId = 'C587E869-1302-4E09-8746-36F254C5D004';
    // let clienteId= 1;
    //criar a estrutura de pergunta e resposta
    /*
      perguntaId:x,
      valorResposta:x,
      opcaoRespostaId:x
    */
   const respostasPessoa = perguntasRespondidas.map(perguntaRespondida=> {
     const {perguntaId, sessaoFormularioPerguntaId,respostas, pergunta} = perguntaRespondida;
     const {ordemExibicao} = pergunta;
     const valorResposta =  respostas.map(r=> {
       const {opcaoRespostaId, valor} = r;
       return {
         opcaoRespostaId,
         valor
       }
     })

     return {
      perguntaId,
      sessaoFormularioPerguntaId,
      ordem:ordemExibicao,
      respostas:valorResposta
     }
   })
    const formularioRespostaPessoa = {
      formularioId,
      termoId,
      pessoaId,
      responsavelInteracao,
      responsavelInteracaoNome,
      respostasPessoa
    }
    return formularioRespostaPessoa;
  },
  perguntasValidarRespostaPorValor,
  clienteFormulario:(state) => state.clienteFormulario
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js